import React, { useState, useEffect } from "react";

const FilterChips = ({  statusList,
     filterData, handleFilterChip }) => {
    let tempStatusList = [], tempDropdownUserList=[];
    if (statusList && statusList.length && filterData.status_id) {
        tempStatusList = statusList.filter(v => {
            return filterData.status_id.includes(v.value)
        })
    }
    return (
        <>
            <div className="selected-chips">
                <ul>
                

{
                        filterData.search_text ?
                            <li>
                                Search Text - {filterData.search_text}
                                <span>
                                    <i className="ic-clearclose" onClick={() => handleFilterChip("search_text")}></i>
                                </span>
                            </li>
                            : ''}
                    
                    
                    {
                        tempStatusList.map((v ,index) => (
                            <li key = {index}>
                                Status - {v.label}
                                <span>
                                    <i className="ic-clearclose" onClick={() => handleFilterChip("status_id", v.value)}></i>
                                </span>
                            </li>
                        ))
                    }
                    
                </ul>
            </div>

        </>
    )
}

export default FilterChips;